import React, {useEffect, useState} from 'react';
import FileUploader from "../Enrollment/FileUploader";
import MerchantEnrollmentAPI from "../../api/MerchantEnrollmentAPI";

function MerchantProfileForm({payload, setPayload, handleNext}) {
    const [data, setData] = useState({
        CategoryID: "",
        SubCategoryID: "",
        About: "",
        Website: "",
        Facebook: "",
        Instagram: "",
        MerchantLogo: null,
        MerchantCover: null
    });

    const [additionals, setAdditionals] = useState({
        Category: "",
        SubCategory: ""
    });

    const [errors, setErrors] = useState({
        CategoryID: "",
        SubCategoryID: "",
        About: "",
        MerchantLogo: "",
        MerchantCover: ""
    });
    const isVisited = Object.keys(payload.MerchantEnrollmentProfile).length !== 0

    useEffect(() => {
        if(isVisited){
            setData(payload.MerchantEnrollmentProfile);
            setAdditionals(payload.Additionals);
        }
    }, []);

    const {
        GetCategories,
        GetSubCategories,
        categoriesList,
        subCategoriesList,
    } = MerchantEnrollmentAPI();

    useEffect(() => {
        GetCategories();
    }, []);

    useEffect(() => {
        if (data.CategoryID)
            GetSubCategories(data.CategoryID);
    }, [data.CategoryID]);

    useEffect(() => {
        if (data.CategoryID && categoriesList)
            setAdditionals({
                ...additionals,
                Category: categoriesList.find(x => x.value === Number(data.CategoryID))?.label,
            })
    }, [data.CategoryID]);

    useEffect(() => {
        if (data.SubCategoryID && subCategoriesList)
            setAdditionals({
                ...additionals,
                SubCategory: subCategoriesList.find(x => x.value === Number(data.SubCategoryID))?.label,
            })
    }, [data.SubCategoryID]);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setData({...data, [name]: value});
        setErrors({...errors, [name]: ""});
    };

    const validate = () => {
        let temp = {...errors};
        temp.CategoryID = data.CategoryID ? "" : "Category field is required.";
        temp.SubCategoryID = data.SubCategoryID ? "" : "Subcategory field field is required.";
        temp.About = data.About.trim() ? "" : "About field is required.";

        //this validation will check this: data.MerchantLogo and data.MerchantCover should be only of type image (check if the file is an image) and do not exceed 2MB
        temp.MerchantLogo = data.MerchantLogo && data.MerchantLogo.type.startsWith("image") && data.MerchantLogo.size < 2000000 ? "" : "This field is required and should only be an image not exceeding 2MB.";
        temp.MerchantCover = data.MerchantCover && data.MerchantCover.type.startsWith("image") && data.MerchantCover.size < 2000000 ? "" : "This field is required and should only be an image not exceeding 2MB.";

        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    };

    const handleContinue = () => {
        if (validate()) {
            setPayload({...payload, MerchantEnrollmentProfile: data, Additionals: {...payload.Additionals, ...additionals}});
            handleNext();
        }
    };

    return (
        <>
            <div className="form-container">
                <div className="form-title">
                    MERCHANT PROFILE
                </div>

                <div className="form-group">
                    <div className="form-label">Merchant Displayed Name</div>
                    <input type="text" className="form-input" value={payload.MerchantEnrollmentInformation.MerchantName}
                           readOnly disabled/>
                </div>

                <div className="input-group">
                    <div className="form-group">
                        <div className="form-label">Category</div>
                        <select name="CategoryID" id="category" className="form-input" onChange={handleChange}>
                            <option value="0">{(isVisited && additionals.Category)? additionals.Category : "Select"}</option>
                            {
                                categoriesList && categoriesList.map(({label, value}, index) => (
                                    <option key={index} value={value}>{label}</option>
                                ))
                            }
                        </select>
                        {errors.CategoryID && <div className="error">{errors.CategoryID}</div>}
                    </div>
                    <div className="form-group">
                        <div className="form-label">Subcategory</div>
                        <select name="SubCategoryID" id="subcategory" className="form-input" onChange={handleChange}>
                            <option value="0">{(isVisited && additionals.SubCategory)? additionals.SubCategory : "Select"}</option>
                            {
                                subCategoriesList && subCategoriesList.map(({label, value}, index) => (
                                    <option key={index} value={value}>{label}</option>
                                ))
                            }
                        </select>
                        {errors.SubCategoryID && <div className="error">{errors.SubCategoryID}</div>}
                    </div>
                </div>

                <div className="form-group">
                    <div className="form-label">About</div>
                    <textarea name="About" id="about" cols="90" rows="12"
                              placeholder="Type a brief description of the company…" onChange={handleChange} value={data.About} />
                    {errors.About && <div className="error">{errors.About}</div>}
                </div>

                <div className="form-group">
                    <div className="form-label">Website</div>
                    <input name="Website" type="text" className="form-input" placeholder="Https://"
                           onChange={handleChange} value={data.Website} />
                </div>

                <div className="input-group">
                    <div className="form-group">
                        <div className="form-label">Facebook</div>
                        <input name="Facebook" type="text" className="form-input" placeholder="Xxx"
                               onChange={handleChange} value={data.Facebook} />
                    </div>

                    <div className="form-group">
                        <div className="form-label">Instagram</div>
                        <input name="Instagram" type="text" className="form-input" placeholder="Xxx"
                               onChange={handleChange} value={data.Instagram}/>
                    </div>
                </div>

                <div className="input-group">
                    <div className="form-group">
                        <div className="form-label file-label">
                            <div className="label-val">Logo</div>
                            <div className="description">(Optimal size 300 x 300px)</div>
                        </div>
                        <FileUploader
                            setFile={(file) => {
                                setData({
                                    ...data,
                                    MerchantLogo: file
                                });
                            }}
                            placeholder={data.MerchantLogo ? data.MerchantLogo.name : "Choose Photo"}
                        />
                        {errors.MerchantLogo && <div className="error">{errors.MerchantLogo}</div>}
                    </div>

                    <div className="form-group">
                        <div className="form-label file-label">
                            <div className="label-val">Coverphoto</div>
                            <div className="description">(Optimal size 640 x 300px)</div>
                        </div>
                        <FileUploader
                            setFile={(file) => {
                                setData({
                                    ...data,
                                    MerchantCover: file
                                });
                            }}
                            placeholder={data.MerchantCover ? data.MerchantCover.name : "Choose Photo"}
                        />
                        {errors.MerchantCover && <div className="error">{errors.MerchantCover}</div>}
                    </div>
                </div>
            </div>
            <button onClick={handleContinue} className="continue-btn">Continue</button>
        </>
    );
}

export default MerchantProfileForm;